import moment from "moment";
import { DATE_FORMAT } from "../constants";
import { POSResponse } from "../interfaces/posResponse";
import { CancerScreeningResultModel } from "../models/cancerScreeningResultModel";

export class CefSharpShell {
  protected CefSharp: any;
  public isShellMode: boolean;

  constructor() {
    this.CefSharp = (window as any).CefSharp;
    if (process.env.REACT_APP_POS_CONNECTED === "true") {
      this.CefSharp = {
        PostMessage: function (obj: any) {
          obj.Callback({ success: true, statusText: "OK" });
        },
      };
    }
    this.isShellMode = this.CefSharp !== undefined;
  }

  checkPosConnection(
    successCallback: (isConnected: boolean) => void,
    failCallback: (errorText: string) => void
  ) {
    if (this.isShellMode) {
      this.CefSharp.PostMessage({
        Type: "PosCheckConnection",
        Callback: (reply: POSResponse) => {
          if (!reply.success) {
            failCallback(reply.statusText);
          }
          successCallback(reply.success);
        },
      });
    }
  }

  isPOSConfigured(successCallback: (shouldHavePos: boolean) => void) {
    if (this.isShellMode) {
      this.CefSharp.PostMessage({
        Type: "PosCheckConfigured",
        Callback: (reply: POSResponse) => {
          if (reply.success) {
            successCallback(true);
          }
        },
      });
    }
  }

  chargeCard(
    amount: number,
    successCallback: (reply: POSResponse) => void,
    failCallback: (statusText: string) => void
  ) {
    if (this.isShellMode) {
      this.CefSharp.PostMessage({
        Type: "Purchase",
        Amount: amount,
        Callback: (reply: POSResponse) => {
          if (!reply.success) {
            failCallback(reply.statusText);
          } else {
            successCallback(reply);
          }
        },
      });
    }
  }

  printBarcode(barcode: string) {
    if (this.isShellMode) {
      this.CefSharp.PostMessage({
        Type: "PrintLabel",
        LabelBarcode: barcode,
        Callback: () => {},
      });
    }
  }

  sendPOSBatch(
    successCallBack: (reply: POSResponse) => void,
    failCallback: (reply: POSResponse) => void
  ) {
    if (this.isShellMode) {
      this.CefSharp.PostMessage({
        Type: "PosSendBatch",
        Callback: (reply: POSResponse) => {
          if (reply.success) {
            successCallBack(reply);
          } else {
            failCallback(reply);
          }
        },
      });
    }
  }

  printTemplateLabel(patient: CancerScreeningResultModel, barcode: string) {
    if (this.isShellMode) {
      this.CefSharp.PostMessage({
        Type: "PrintTemplateLabel",
        LabelDocumentName: "documentName",
        LabelTemplateParameters: {
          name: patient?.personName || "",
          nationalId: patient?.personSsn || "",
          samplingDate: patient?.examinationDateTime
            ? moment(patient.examinationDateTime).format(DATE_FORMAT)
            : "",
          barcode: barcode,
          institutionId: patient?.locationNumber || "",
          doctorId: patient?.requestorNumber || "",
        },
        Callback: () => {},
      });
    }
  }
}
